import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';

const endpoint = settings.api_host + "/user/auth";

const apiLogin = async (email, password) => {
	if (!email) {
		throw new Error("Missing email");
	}
	if (!password) {
		throw new Error("Missing password");
	}

	let params = {
		email,
		password
	};
	
	try {
		const response = await axios({
			method: 'post',
			url: endpoint,
			data: params,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export default apiLogin;


// WEBPACK FOOTER //
// ./src/api/login.js